export default function createEventEmitter<TData>() {
  const listeners: ((data: TData) => void)[] = [];

  return {
    addListener(handler: (data: TData) => void) {
      listeners.push(handler);
      return () => {
        const handlerIndex = listeners.indexOf(handler);
        if (handlerIndex !== -1) {
          listeners.splice(handlerIndex, 1);
        }
      };
    },
    emitEvent(data: TData) {
      listeners.forEach((handler) => handler(data));
    },
  };
}
